<div class="miangbdpg-boxxcont">
  <div class="col" [ngClass]="{ navigable: statsCard.isNavigable }" (click)="navigate(statsCard)">
    <div class="p-3">
      <div>
        <h3>{{ statsCard.count }}</h3>
        <p>{{ statsCard.label }}</p>
      </div>
    </div>
  </div>
</div>
